import PageWrapper from "../componenti/PageWrapper";
import TabellaOrari from "../componenti/TabellaOrari";
import PageContent from "../componenti/PageContent";
import { Typography, Stack, Box, Divider, Link } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

export default function Corsi() {
  return (
    <PageWrapper>
      <PageContent title="Gli orari di yoga">
        <Box>
          <Stack
            divider={<Divider orientation="vertical" flexItem />}
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Durata Lezione</Typography>
              <Typography variant="body2" >1 ora</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Frequenza</Typography>
              <Typography variant="body2">Settimanale</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Cosa Portare</Typography>
              <Typography variant="body2" >Tappetino e cuscino (zafu)</Typography>
            </Box>
          </Stack>
        </Box>

        <TabellaOrari />

        <Box
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            p: 3,
            backgroundColor: 'action.hover'
          }}
        >
          <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
            <EventAvailableIcon color="primary" fontSize="small" />
            <Typography variant="h6" component="h3">Attività Speciali</Typography>
          </Stack>
          <Typography sx={{ mt: 1.5, color: 'text.secondary' }}>
            Oltre agli incontri settimanali, proponiamo periodicamente eventi unici come bagni di gong, serate a tema e ritiri yoga, annunciati nella sezione news.
          </Typography>
        </Box>
      </PageContent>
    </PageWrapper>
  );
}